import React, { Component } from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";
import AuditTrailSummaryView from "./AuditTrailSummaryView";
import { getAuditTrailSummary } from "../../../services";
import { showErrorNotification, getProp } from "../../../helpers";

class AuditTrailSummaryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      summaryData: null,
      isLoading: false,
      startDate: this.getDefaultStartDate(),
      endDate: new Date().toISOString().split("T")[0]
    };
  }

  componentDidMount() {
    this.fetchAuditTrailSummary();
  }

  getDefaultStartDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date.toISOString().split("T")[0];
  };

  fetchAuditTrailSummary = () => {
    this.setState({ isLoading: true });
    const { startDate, endDate } = this.state;
    const { clinicId } = this.props;

    getAuditTrailSummary(startDate, endDate, clinicId)
      .then(response => {
        this.setState({ isLoading: false });
        const getSuccess = getProp(["data", "success"]);
        const getData = getProp(["data", "data"]);
        const getErrors = getProp(["data", "errors"]);

        if (getSuccess(response)) {
          const summaryData = getData(response);
          this.setState({ summaryData });
        } else if (getErrors(response)) {
          const { errors } = response.data;
          let error = errors;
          if (Array.isArray(errors)) {
            [error] = errors;
          }
          showErrorNotification(
            error.title || "Failed to fetch audit trail summary"
          );
        }
      })
      .catch(() => {
        this.setState({ isLoading: false });
        showErrorNotification("Failed to fetch audit trail summary");
      });
  };

  handleDateRangeChange = (startDate, endDate) => {
    this.setState({ startDate, endDate }, () => {
      this.fetchAuditTrailSummary();
    });
  };

  render() {
    const { summaryData, isLoading, startDate, endDate } = this.state;

    return (
      <Spin spinning={isLoading}>
        <AuditTrailSummaryView
          summaryData={summaryData}
          startDate={startDate}
          endDate={endDate}
          onRefresh={this.fetchAuditTrailSummary}
          onDateRangeChange={this.handleDateRangeChange}
        />
      </Spin>
    );
  }
}

AuditTrailSummaryContainer.propTypes = {
  clinicId: PropTypes.string.isRequired
};

export default AuditTrailSummaryContainer;
